import { FC, forwardRef, useState } from 'react'
import { Box, Typography, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import { Modal } from './Modal'

import classNames from 'classnames'

const Button = styled(Box)(({ theme }) => ({
    '&:hover': {
        cursor: 'pointer',
    },
}))

const ModalHeader = styled(Box)(({ theme }) => ({
    padding: '2rem',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    backgroundColor: '#0057A0',
    backgroundImage: 'linear-gradient(105deg, #682a94, #05afe0)',
}))

const Content = styled(Box)(({ theme }) => ({
    color: '#000000',
    marginTop: '6.4rem',
}))

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1.6rem',
    fontWeight: 'bold',
    color: '#ffffff',
}))

const CloseIcon = styled(Box)(({ theme }) => ({
    position: 'absolute',
    right: '2rem',
    top: '1.6rem',
    height: '1rem',
    cursor: 'pointer',
}))

const getIframeStyles = (height?: string) => ({
    border: 'none',
    width: '100%',
    height: height ? height : '78vh',
    margin: 0,
    padding: 0,
})

export type EidIFrameProps = {
    url: string
    title: string
    className?: string
    height?: string
    children?: React.ReactNode
}

export const EidIFrame: FC<EidIFrameProps> = forwardRef((props, ref) => {
    const [showModal, setShowModal] = useState(false)

    const header = (
        <ModalHeader>
            <Title>{props.title}</Title>
            <CloseIcon>
                <Icon
                    name="Close"
                    color="#ffffff"
                    onClick={() => setShowModal(false)}
                />
            </CloseIcon>
        </ModalHeader>
    )

    return (
        // @ts-ignore
        <div ref={ref}>
            <Modal open={showModal} header={header}>
                <Content>
                    {showModal && (
                        <iframe
                            title={props.title}
                            style={getIframeStyles(props.height)}
                            src={props.url}
                        />
                    )}
                </Content>
            </Modal>
            <Button
                onClick={() => setShowModal(true)}
                className={classNames(props.className)}
            >
                {props.children}
            </Button>
        </div>
    )
})
